// TODO: 本檔案逐步淘汰，請勿新增任何新功能在此檔案

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactDOMServer from 'react-dom/server';
import { CheckLogIn, permisionURL } from "./DomainTS";
import { IndexedDBClass } from "./indexedDB";

const homepage = sessionStorage.home_page;

// #region 日期時間類別
/**
 * 時間處理
 */
export const DateTimeFormate = (() => {
  /**
   * @description 時間改字串
   * @param { Date } date 不給值就預設現在時間，ex: new Date("2023-04-25")
   * @param { string } Mode
   * @param { string } joinDate ex: "/"、"-"
   * @param { string } joinTime ex: ":"
   */
  const DateTimeToString = ({ type = null, date = null, Mode = "yyyyMMdd", joinDate = "/", joinTime = ":", space = " " }) => {
    let EditTime, year, month, day, hour, minute, second = "";
    if (date) {
      if (type === "newDate") {
        year = date.getFullYear();
        month = (date.getMonth() + 1).toString().padStart(2, '0');
        day = date.getDate().toString().padStart(2, '0');
        hour = date.getHours().toString().padStart(2, '0');
        minute = date.getMinutes().toString().padStart(2, '0');
        second = date.getSeconds().toString().padStart(2, '0');
      } else {
        year = date.substring(0, 4);
        month = date.substring(5, 7);
        day = date.substring(8, 10);
        hour = date.substring(11, 13);
        minute = date.substring(14, 16);
        second = date.substring(17, 19);
      }
    } else {
      let nd = new Date();
      year = nd.getFullYear();
      month = ("0" + (nd.getMonth() + 1)).slice(-2);
      day = ("0" + nd.getDate()).slice(-2);
      hour = ("0" + nd.getHours()).slice(-2);
      minute = ("0" + nd.getMinutes()).slice(-2);
      second = ("0" + nd.getSeconds()).slice(-2);
    }
    switch (Mode) {
      case "yyyyMMddHHmmss":
        EditTime = `${year}${joinDate}${month}${joinDate}${day}${space}${hour}${joinTime}${minute}${joinTime}${second}`;
        break;
      case "yyyyMMddHHmm":
        EditTime = `${year}${joinDate}${month}${joinDate}${day}${space}${hour}${joinTime}${minute}`;
        break;
      case "yyyyMMdd":
        EditTime = `${year}${joinDate}${month}${joinDate}${day}`;
        break;
      case "yyyyMM":
        EditTime = `${year}${joinDate}${month}`;
        break;
      case "MMddHHmm":
        EditTime = `${month}${joinDate}${day}${space}${hour}${joinTime}${minute}`;
        break;
      case "MMdd":
        EditTime = `${month}${joinDate}${day}`;
        break;
      case "HHmmss":
        EditTime = `${hour}${joinTime}${minute}${joinTime}${second}`;
        break;
      case "HHmm":
        EditTime = `${hour}${joinTime}${minute}`;
        break;
      default:
        EditTime = `${year}${joinDate}${month}${joinDate}${day}`;
        break;
    }
    return EditTime;
  };

  /**
   * @description 本月第一天
   */
  const getMonthStart = (date = null) => {
    let d = date === null ? new Date() : date;
    let start = new Date(d.getFullYear(), d.getMonth(), 1);
    return new Date(start);
  };

  /**
   * @description 本月最後一天
   */
  const getMonthEnd = (date = null) => {
    let d = date === null ? new Date() : date;
    let end = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    return new Date(end);
  };

  return {
    getMonthStart,
    getMonthEnd,
    DateTimeToString,
  };
})();
// #endregion

// #region 權限類別
/**
 * 取得權限
 * 本地也可以抓到測試機所存的權限
 * @param {string} code 檔案名稱
 */
export const GetPermission = async (account) => {
  let path = "";
  if (window.location.origin.indexOf("localhost") !== -1 || window.location.origin.indexOf("127.0.0.1") !== -1) {
    path = `${permisionURL}/Users/${account}/permission.json?x=${Date.now()}`;
  } else {
    path = `${window.location.protocol}//${window.location.host}/_${sessionStorage.company_code}/Users/${account}/permission.json?x=${Date.now()}`;
  }
  return await fetch(path).then((data) => data.json());
};

/** 檢查頁面群組及頁面的權限 X 檢查按鈕的權限 [合體]
 * @param {string} pageName 頁面名稱
 * @param {array} btnArr 按鈕名稱們
 * @param {string} path 頁面路徑 => 為了可以取得其他頁面的權限
 * @param {boolean} getPermission 是否要取得權限???
 */
export const useCheckLogInXPermission = (pageName = null, btnArr = [], path = null, getPermission = false) => {
  const pagePath = path ? `${path}/${pageName}` : window.location.pathname;
  let PermissionRes = [];
  const navigate = useNavigate();
  const [resPermissionBtn, setResPermissionBtn] = useState({});

  useEffect(() => {
    CheckLogIn().then((res) => {
      if (res.success) {
        GetPermission(res.data.path).then(async (r) => {
          PermissionRes = r;
          let obj = {};
          let nowState = await nowPageState({
            sidebar: r.find((ele) => ele.name === homepage).children.find((ele) => ele.name === "sidebar"),
            groupCode: pagePath.split("/")[2],
            pageCode: pagePath.split("/")[pagePath.split("/").length - 1],
          });
          for (let i in btnArr) {
            let btnBool = await btnState(btnArr[i], nowState, pageName);
            obj = { ...obj, [btnArr[i]]: btnBool };
          }
          setResPermissionBtn(obj);
        });
      }
      else navigate("/System/Login");
    });
  }, []);

  return getPermission ? { data: PermissionRes, Btn: resPermissionBtn } : resPermissionBtn;
};

//檢查頁面群組及頁面的權限
export const nowPageState = async (obj) => {
  let groupArr = obj.sidebar === null ? [] : obj.sidebar.children.filter((i) => i.code === obj.groupCode);
  let groupY = groupArr.length > 0 ? true : false;
  let pageArr = groupY ? groupArr[0].children.filter((i) => i.code === obj.pageCode) : [];
  let pageY = pageArr.length > 0 ? (pageArr[0].code === obj.pageCode ? true : false) : false;
  return {
    groupArr: groupArr,
    groupY: groupY,
    pageArr: pageArr,
    pageY: pageY,
  };
};

// 檢查按鈕的權限
export const btnState = async (btnId, Arr, pageName) => {
  if (Arr.pageArr.length > 0) {
    return Arr.pageArr[0].children.some((i) => i.ctrl_code === btnId);
  } else {
    let pageArr = Arr.groupArr[0].children;
    if (pageName) pageArr = pageArr.filter((j) => j.code === pageName);
    return pageArr[0].children.some((i) => i.ctrl_code === btnId);
  }
};
// #endregion

// #region idb builder
/**
 * @author Daniel Wang
 * 2023-01-05
 * @description 回應一個indexedDBClass 的物件，不要直接去 new IndexedDBClass，用這個function
 * factory 算是結合輔助工具 配合當前系統功能的地方
 * @returns indexedDBClass
 * indexedDBClass 的class有哪些功能可以參考 IndexedDBClass.js
 *
 */
export const get_ECC_indexedDB_factory = async () => {
  try {
    let idb = new IndexedDBClass("ECCNET");
    let r = await idb
      .openIndexedDB()
      .then((res) => res)
      .catch((error) => {
        console.log("%cIDB開啟時發生錯誤", "font-size: 1.5rem; background:red;");
        console.error(error.message);
        return error;
      });
    if (r.success) return idb;
    else return r.data;
  } catch (e) {
    console.warn("ECCNET warning: ", e);
    return null;
  }
};
// #endregion

// #region 其餘雜類
/**
 * 排出重複資料
 * @param {*} res
 */
export const ArrayNotRepeat = (data, key) => {
  if (key) {
    const uniqueMIdObjects = {};
    for (let item of data) {
      if (!uniqueMIdObjects[item[key]]) uniqueMIdObjects[item[key]] = item;
    }
    return Object.values(uniqueMIdObjects);
  } else {
    const uniqueKeys = {};
    const result = [];
    for (let i = 0; i < data.length; i++) {
      let obj = data[i];
      let key = Object.keys(obj)[0];
      if (!uniqueKeys[key]) {
        result.push(obj);
        uniqueKeys[key] = true;
      }
    }
    return result;
  }
};

// /**
//  * @description 訂單狀態判斷
//  * @returns 四個狀態 Chip color
//  */
// export const OrderStatus = (statusName) => {
//   let str = "default";
//   if (statusName) {
//     if (statusName.includes('已取消')) return str = "error";
//     else if (statusName.includes('未')) return str = "error";
//     else if (statusName.includes('中')) return str = "warning";
//     else if (statusName.includes('待')) return str = "info";
//     else if (statusName.includes('確認')) return str = "info";
//     else if (statusName.includes('完成') || statusName.includes('送達') || statusName.includes('退款完成') || statusName.includes('已收到退貨')) return str = "success";
//     else if (statusName.includes('已') || statusName.includes('退款中')) return str = "info";
//     else return str;
//   } else return str;
// }